import { TrackerType } from "./TrackerType";

export const trackerToContentIdentifierMap = {
  [TrackerType.Sleep]: "sleep",
  [TrackerType.Activity]: "activity",
  [TrackerType.BreathingExercises]: "breathingexercises",
  [TrackerType.Steps]: "steps",
  [TrackerType.Water]: "water",
};
